import { LorebookStatus } from "@next-platform/packages-ts-types";

export default function isLorebookDetailsNeedAlert(lorebookStatus: LorebookStatus) {
  return lorebookStatus === LorebookStatus.NEEDS_REVIEW;
}
